import React from 'react';
import TranscriptPDF from 'components/TranscriptPDF';
import { useTranslation } from '@omilia/providers';
import { useSelector } from 'react-redux';
import { getLocale } from 'store/services/session/selectors';
import {
  SButtonGroup,
  SButton,
  SDownloadPDF,
  SContainer,
  SMessage,
} from './styled';

interface SessionEndMessageProps {
  restartChat: () => void;
  thread: any[];
  title: string;
  withTranscript: boolean;
}

const SessionEndMessage = ({
  restartChat,
  thread,
  title,
  withTranscript = false,
}: SessionEndMessageProps) => {
  const { t } = useTranslation();
  const locale = useSelector(getLocale);
  const messageTitle = t('session.sessionEnded');
  const message = t('session.sessionEndedMessage', {
    withTranscript: !withTranscript ? t('session.orDownloadTranscript') : '',
  });

  return (
    <SContainer>
      <SMessage>
        {messageTitle} {message}
      </SMessage>
      <SButtonGroup>
        {withTranscript && (
          <SDownloadPDF
            key={thread.length}
            document={
              <TranscriptPDF
                thread={thread}
                title={title}
                endMessage={messageTitle}
                locale={locale}
              />
            }
            fileName={t('files.fileName')}
          >
            {t('session.downloadTranscript')}
          </SDownloadPDF>
        )}
        <SButton onClick={restartChat}>{t('session.startNewChat')}</SButton>
      </SButtonGroup>
    </SContainer>
  );
};

export default SessionEndMessage;
